import React from 'react';
import styled from 'styled-components';
import { ICardBrand } from '../../../../details/paymentMethods/cards/cardBrands/cardBrand.interface';
import { cardBrandsIcons } from '../../../../details/paymentMethods/cards/cardBrands/cardBrandsIcons.constant';

interface CardLogoProps {
    backgroundUrl: string;
    top?: string;
}

const CardLogo = styled.div<CardLogoProps>`
    background: url('${(props) => props.backgroundUrl}');
    background-repeat: no-repeat;
    background-size: contain;
    height: 34px;
    width: 55px;
`;

interface ICardBrandIconProps {
    cardBrand?: ICardBrand;
    cardBrandName?: string;
    top?: string;
}

export const CardBrandIcon = ({ cardBrand, top }: ICardBrandIconProps) => {
    return (
        <CardLogo
            backgroundUrl={cardBrand ? cardBrandsIcons[cardBrand.iconId] : ''}
            role="img"
            aria-label={cardBrand?.apiName}
            tabIndex={0}
        />
    );
};
